
import i18n from 'i18next';

export const eventAnalyticsConstants = {
  GET_EVENT_ANALYTICS_REQUEST: 'GET_EVENT_ANALYTICS_REQUEST',
  GET_EVENT_ANALYTICS_SUCCESS: 'GET_EVENT_ANALYTICS_SUCCESS',
  GET_EVENT_ANALYTICS_FAILURE: 'GET_EVENT_ANALYTICS_FAILURE',
};

export const eventAnalyticsMetadata = (theme, t = i18n.t.bind(i18n)) => ({
  breakdown_by_state: {
    sortOrder: ['open', 'closed'],
    colors: [theme.colors.red, theme.primaryColor],
    route: '/devices',
    title: t('eventAnalytics.charts.breakdownByState', { defaultValue: 'Breakdown by State' }),
    id: 'event-analytics-breakdown-by-state',
    widgetType: 'DONUT_CHART'
  },
  avg_duration: {
    sortOrder: [],
    colors: [theme.primaryColor],
    route: '/devices',
    title: t('eventAnalytics.charts.averageDurationOfEventsInDays', { defaultValue: 'Average Duration of Events in Days' }),
    id: 'event-analytics-avg-duration',
    widgetType: 'BAR_CHART'
  },
  num_of_events: {
    sortOrder: [],
    colors: [theme.primaryColor],
    route: '/devices',
    title: t('eventAnalytics.charts.numberOfEvents', { defaultValue: 'Number of Events' }),
    id: 'event-analytics-num-of-events',
    widgetType: 'BAR_CHART'
  },
  duration_of_events: {
    title: t('eventAnalytics.charts.durationOfEventsInDays', { defaultValue: 'Duration of Events, in Days' }),
    legend: { position: 'none' },
    chartArea: { width: '80%' },
    height: 200,
    hAxis: {
      title: t('eventAnalytics.charts.axes.duration', { defaultValue: 'Duration' }),
    },
    vAxis: {
      title: t('eventAnalytics.charts.axes.events', { defaultValue: 'Events' })
    },
    colors: [theme.primaryColor],
    widgetType: 'HISTOGRAM'
  }
});

export const widgetTypes = {
  DONUT_CHART: 'DONUT_CHART',
  BAR_CHART: 'BAR_CHART',
  HISTOGRAM: 'HISTOGRAM'
};
